import { useMemo } from 'react';

import { differenceInCalendarDays, formatDistanceToNow } from 'date-fns';

export const useRelativeDate = (dateString: string) => {
  const date = useMemo(() => new Date(dateString), [dateString]);
  const diff = useMemo(
    () => differenceInCalendarDays(new Date(), date),
    [date],
  );
  const relative = useMemo(() => formatDistanceToNow(date), [date]);
  const absolute = useMemo(() => date.toLocaleString(), [date]);
  return { relative, absolute, showRelative: diff <= 6 };
};
